/**
 *
 * @param {String} input
 * @param {String} separator
 * @returns
 */
const processHSLA = (input, separator) => {
  const space = /[▂|▃]/.test(input);

  const splitter = space ? "▂" : separator;

  let hsla = input.slice(5, -1).split(splitter);

  /** Handle space-separated syntax with a slash for alpha */
  if (space) {
    hsla[3] = hsla[4];
  }

  let h = parseFloat(hsla[0]);
  let s = parseFloat(hsla[1]) / 100;
  let l = parseFloat(hsla[2]) / 100;
  let a = hsla[3] ? parseFloat(hsla[3]) / 100 : 1;

  /** Convert HSL to RGB */
  const c = (1 - Math.abs(2 * l - 1)) * s;
  const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
  const m = l - c / 2;

  let r, g, b;

  if (0 <= h && h < 60) {
    r = c;
    g = x;
    b = 0;
  } else if (60 <= h && h < 120) {
    r = x;
    g = c;
    b = 0;
  } else if (120 <= h && h < 180) {
    r = 0;
    g = c;
    b = x;
  } else if (180 <= h && h < 240) {
    r = 0;
    g = x;
    b = c;
  } else if (240 <= h && h < 300) {
    r = x;
    g = 0;
    b = c;
  } else {
    r = c;
    g = 0;
    b = x;
  }

  /** Convert to [0,255] range */
  r = Math.round((r + m) * 255);
  g = Math.round((g + m) * 255);
  b = Math.round((b + m) * 255);

  return `rgba(${r}${separator}${g}${separator}${b}${separator}${a})`;
};

export default processHSLA;
